import api from 'api/api'

export const GET_BRANCHES = "[BRANCHES] GET BRANCHES"

export function getBranchesAction() {
  const request = api.get('/branches')
  return (dispatch) => {
    dispatch({ type: GET_BRANCHES, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_BRANCHES, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_BRANCHES, error)
    }).finally(() => {
      dispatch({ type: GET_BRANCHES, payload: { loading: false } })
    })
  }
}